import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { sidebarModuleGuard } from './core/guards/sidebar-module.guard';
import { SiteLayout } from './layout/site-layout';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login').then((m) => m.LoginPage),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./auth/forgot-password/forgot-password').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/reset-password/reset-password').then((m) => m.ResetPasswordPage),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () => import('./auth/reset-password/reset-password').then((m) => m.ResetPasswordPage),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./auth/sign-up/sign-up').then((m) => m.SignUpPage),
  },
  {
    path: 'status',
    loadComponent: () =>
      import('./auth/org-signup-status/org-signup-status').then((m) => m.ApplicationSubmittedPage),
  },
  {
    path: 'staff-signup',
    loadComponent: () =>
      import('./features/staff-members/staff-signup/staff-signup').then((m) => m.StaffSignupPage),
  },
   {
    path: '',
    component: SiteLayout,
    canActivate: [authGuard, sidebarModuleGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./layout/site.routing').then((m) => m.siteRoutes),
      },
    ],
  },
  {
    path: 'not-found',
    loadComponent: () => import('./shared/ui/not-found/not-found').then((m) => m.NotFoundPage),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
